// extracted by mini-css-extract-plugin
export default {"text-align-left":"text-align-left__a-qv2","icon-class":"icon-class__IBCe3","warning":"warning__5EkXY","card":"card__94hUh","no-cv-message":"no-cv-message__H4znc"};